import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CommentService } from 'src/app/services/comment.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SensorRecordService } from 'src/app/services/sensorRecord.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  standalone: false,
  selector: 'app-edit-comment',
  templateUrl: './edit-comment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./edit-comment.component.scss']
})
export class EditCommentComponent implements OnInit, OnChanges {
  @Input() show;
  @Input() comment;
  @Input() triggerPopulateForm;

  @Output() hideFormEmit = new EventEmitter<any>();
  @Output() resetTriggerPopulateFormEmit = new EventEmitter<any>();
  @Output() updateGraphAndNotes = new EventEmitter<any>();

  commentForm: UntypedFormGroup;
  commentFormSubmitted: boolean = false;

  constructor(private sensorRecordService: SensorRecordService,
    private toastService: ToastService,
    private loaderService: LoaderService,
    private commentService: CommentService,
    private fb: UntypedFormBuilder) { }

  get cf() {
    return this.commentForm.controls;
  }

  ngOnInit(): void {
    this.commentForm = this.fb.group({
      id: null,
      text: ["", Validators.required],
      fromDate: 0,
      toDate: 0,
      endPointId: null,
      dateCreated: 0
    });
  }

  ngOnChanges() {
    if (this.triggerPopulateForm) {
      this.commentFormSubmitted = false;
      this.populateForm();
      this.resetTriggerPopulateForm();
    }
  }

  hideForm() {
    this.hideFormEmit.emit(true);
  }

  resetTriggerPopulateForm() {
    this.resetTriggerPopulateFormEmit.emit(true);
  }

  submitForm() {
    if (this.commentFormSubmitted) return;
    this.commentFormSubmitted = true;
    if(this.commentForm.valid) {
      this.commentService.update(this.commentForm.value).subscribe(
        data => {
          this.toastService.showSuccess('Comment updated successfully', true);
          this.updateGraphAndNotes.emit(true);
          this.hideForm();
          this.loaderService.hide();
        },
        error => {
          this.toastService.displayErrorMessage('Something went wrong', true);
          this.loaderService.hide();
        }
      );
    }
  }

  populateForm() {
    this.commentForm.patchValue({
      id: this.comment?.id,
      text: this.comment?.text,
      fromDate: this.comment?.fromDate,
      toDate: this.comment?.toDate,
      endPointId: this.comment?.endPointId,
      dateCreated: this.comment?.dateCreated,
    })
  }

}